module.exports = __webpack_public_path__ + "static/media/XIOT.8d18b0e4.png";